export const Black = '#000';
export const Black60 = colorToRgba(Black, 0.6);
export const White = '#FFF';
export const Blue = '#007AFF';
export const Sky = '#D7EBFF';
export const Pink = '#FFE1E1';
export const Blood = '#E51739';
export const GrayLight = '#E1E1EB';
export const Gray = '#C8C8D2';
export const GrayDark = '#7A7A82';
export const GrayCream = '#F0F0F5';
export const Night = '#36363C';
export const Night80 = colorToRgba(Night, 0.8);
export const Gold = '#B89125';
export const Grass = '#00A546';
export const Mint = '#DEF4E0';
export const Cream = '#FCF5CC';
export function colorToRgba(hexColor, alpha = 1) {
    return `rgba(${(makeSixDigitsColor(hexColor)
        .substr(1)
        .match(/../g) || []).map(x => +`0x${x}`)},${alpha})`;
}
export function makeSixDigitsColor(hexColor) {
    hexColor = hexColor.replace('#', '');
    if (hexColor.length === 3) {
        hexColor = hexColor
            .split('')
            .map(function (hexColor) {
            return hexColor + hexColor;
        })
            .join('');
    }
    return `#${hexColor}`;
}
//# sourceMappingURL=colors.js.map